type Lazy<T> = () => T;

export const headUntilSome = <T>([promise, ...promises]: Array<
  Lazy<Promise<T>>
>): Promise<T> => promise?.().then((value) => value ?? headUntilSome(promises));
